module.exports = __webpack_public_path__ + "static/Regulamin-promocji-luty-2025-en-ef2fc4cffaf0448820b5db6ede516db4.pdf";